import * as React from "react";
import {FreeTextField} from "../Components/Form/FreeTextField";
import {styled} from "@mui/material";
import {UnsuccessfulResponse} from "./Components/UnsuccessfulResponse";
import { useForm } from "../../hooks/use_form_v2";
import { Form } from "../Components/Form/Form/Form";
import { PasswordField } from "../Components/Form/PasswordField";
import { LoginForm as LoginFormHandler, ILoginForm } from "../../forms/login_form";
import { IAuthRequest } from "../../stores/auth";
import { CheckboxField } from "../Components/Form/CheckboxField";

const Container = styled('div')(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
}));

interface ILoginFormProps {
    error: string;
    onSubmit(data: IAuthRequest): Promise<any>;
}

export interface ILoginFormState {
    email: string;
    password: string;
    rememberMe: boolean;
}

export const LoginForm = ({error, onSubmit}: ILoginFormProps) => {
    const form = useForm<ILoginForm, IAuthRequest>(new LoginFormHandler());
    const { register, toRequest } = form;

    const handleSubmit = (values: ILoginForm) => {
        return onSubmit(toRequest(values));
    };

    return (
        <Container>
            {'' !== error && <UnsuccessfulResponse message={error} />}

            <Form form={form} onSubmit={handleSubmit} submitButtonProps={{label: 'Sign in', fullWidth: true}}>
                <Form.Field type={FreeTextField} {...register('email')} />
                <Form.Field type={PasswordField} {...register('password')} />
                <Form.Field type={CheckboxField} {...register('rememberMe')} />
            </Form>
        </Container>
    );
}
